import { loadi18nLanguageAsync } from '@/plugins/i18n';
import { loadQuasarLanguageAsync } from '@/plugins/quasar';
const languages = ['nl', 'en-us'];
const loadedLanguages = [];
export default function (lang) {
    if (languages.includes(lang)) {
        if (!loadedLanguages.includes(lang)) {
            loadi18nLanguageAsync(lang);
            loadQuasarLanguageAsync(lang);
            loadedLanguages.push(lang);
        }
    }
}
